import axios from 'axios';

export async function getCourseCardInfo(id: number) {
    const r = await axios.get(`/documents/cardInfo/${id}/`);
    return r.data as Promise<any>;
}
